module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-28.1141f0e1.png";